export default {
  FS_ADJUST_EVENT_LOGS: {
    path: '/fs-adjust-event-logs',
    name: 'fs_adjust_event_logs',
    meta: {
      requiresAuth: true
    },
    component: () => import('@fs_views/AdjustEventLogs')
  },
  FS_USERS: {
    path: '/fs-users',
    name: 'fs_users',
    meta: {
      requiresAuth: true
    },
    component: () => import('@fs_views/Users/UsersIndex')
  },
  FS_USERS_EXPORT: {
    type: 'function',
    path: 'fs_users_export',
    name: 'fs_users_export',
    permission: 'fs_users_export',
    meta: {
      requiresAuth: true
    }
  },
  FS_USERS_DELETE: {
    type: 'function',
    path: 'fs_users_delete',
    name: 'fs_users_delete',
    permission: 'fs_users_delete',
    meta: {
      requiresAuth: true
    }
  },
  FS_COMPLETES: {
    path: '/fs-completes',
    name: 'fs_completes',
    meta: {
      requiresAuth: true,
      quickLink: true,
      project: 'fs',
      title: 'Completes',
      order: 4
    },
    component: () => import('@fs_views/Completes/index')
  },
  FS_USER_DETAILS: {
    path: '/fs-user/:userId',
    name: 'fs_user_details',
    meta: {
      requiresAuth: true,
      quickLink: true,
      project: 'fs',
      title: 'User Details',
      order: 0,
      main: true
    },
    component: () => import('@fs_views/Users/UserDetails')
  },
  FS_CLAIMS: {
    path: '/fs-claims',
    name: 'fs_claims',
    meta: {
      requiresAuth: true,
      quickLink: true,
      project: 'fs',
      title: 'Claims',
      order: 2
    },
    component: () => import('@fs_views/Claims/ClaimsIndex')
  },
  FS_EMAILS: {
    path: '/fs-emails',
    name: 'fs_emails',
    meta: {
      requiresAuth: true,
      quickLink: true,
      project: 'fs',
      title: 'E-Mails',
      order: 3
    },
    component: () => import('@fs_views/Emails/EmailsIndex')
  },
  FS_EMAIL_STATISTICS: {
    path: '/fs-email-statistics',
    name: 'fs_email_statistics',
    meta: {
      requiresAuth: true
    },
    component: () => import('@fs_views/Emails/EmailStatisticsIndex.vue')
  },
  FS_TRANSACTIONS: {
    path: '/fs-transactions',
    name: 'fs_transactions',
    meta: {
      requiresAuth: true,
      quickLink: true,
      project: 'fs',
      title: 'Transactions',
      order: 1
    },
    component: () => import('@fs_views/Transactions/TransactionsIndex')
  },
  FS_PERFORMANCE: {
    path: '/fs-performance',
    name: 'fs_performance',
    meta: {
      requiresAuth: true
    },
    component: () => import('@fs_views/Performance/PerformanceIndex')
  },
  FS_PERFORMANCE_EXPORT: {
    type: 'function',
    path: 'fs_performance_export',
    name: 'fs_performance_export',
    permission: 'fs_performance_export',
    meta: {
      requiresAuth: true
    }
  },
  FS_REWARDS: {
    path: '/fs-rewards',
    name: 'fs_rewards',
    meta: {
      requiresAuth: true
    },
    component: () => import('@fs_views/Rewards')
  },
  FS_AFFILIATE_PARTNERS: {
    path: '/fs-affiliate-partners',
    name: 'fs_affiliate_partners',
    meta: {
      requiresAuth: true
    },
    component: () => import('@fs_views/AffiliatePartners/AffiliatePartnersIndex')
  },
  FS_TRIGGERS: {
    path: '/fs-triggers',
    name: 'fs_triggers',
    meta: {
      requiresAuth: true
    },
    component: () => import('@fs_views/Triggers/TriggersIndex')
  },
  FS_COHORT_ANALYSIS: {
    path: '/fs-cohort-analysis',
    name: 'fs_cohort_analysis',
    meta: {
      requiresAuth: true
    },
    component: () => import('@fs_views/CohortAnalysis/CohortAnalysisIndex.vue')
  },
  FS_COHORT_ANALYSIS_EXPORT: {
    type: 'function',
    path: 'fs_cohort_analysis_export',
    name: 'fs_cohort_analysis_export',
    permission: 'fs_cohort_analysis_export',
    meta: {
      requiresAuth: true
    }
  },
  FS_COHORT_ANALYSIS2: {
    path: '/fs-cohort-analysis-2',
    name: 'fs_cohort_analysis_2',
    meta: {
      requiresAuth: true
    },
    component: () => import('@fs_views/CohortAnalysis/CohortAnalysisIndexNew.vue')
  },
  FS_BOGDAN_BONUS: {
    path: '/fs-bogdan-bonus',
    name: 'fs_bogdan_bonus',
    meta: {
      requiresAuth: true
    },
    component: () => import('@fs_views/BogdanBonus')
  },
  FS_LOG_SPEND: {
    path: '/fs-log-spend',
    name: 'fs_log_spend',
    meta: {
      requiresAuth: true
    },
    component: () => import('@fs_views/LogSpend')
  },
  FS_OFFER_WALL_PERFORMANCE: {
    path: '/fs-offerwall-performance',
    name: 'fs_offer_wall_performance',
    meta: {
      requiresAuth: true,
      quickLink: true,
      project: 'fs',
      title: 'Offerwall Performance',
      order: 6
    },
    component: () => import('@fs_views/OfferWallPerformance')
  },
  FS_SETTINGS: {
    path: '/fs-settings',
    name: 'fs_settings',
    meta: {
      requiresAuth: true
    },
    component: () => import('@fs_views/Settings')
  },
  FS_FRONTEND_SETTINGS: {
    path: '/fs-frontend-settings',
    name: 'fs_frontend_settings',
    meta: {
      requiresAuth: true
    },
    props: { project: 'five-surveys' },
    component: () => import('@ps_views/shared/frontend-settings/FrontendSettingsIndex.vue')
  },
  FS_CAMPAIGN_SETTINGS: {
    path: '/fs-campaign-settings',
    name: 'fs_campaign_settings',
    meta: { requiresAuth: true },
    props: { project: 'five-surveys' },
    component: () => import('@ps_views/shared/campaign-settings/CampaignSettingsIndex.vue')
  },
  FS_TUNE_REJECTION_SETTINGS: {
    path: '/fs-tune-rejection-settings',
    name: 'fs_tune_rejection_settings',
    meta: { requiresAuth: true },
    props: { project: 'five-surveys' },
    component: () => import('@ps_views/shared/tune-rejection-settings/TuneRejectionSettingsIndex.vue')
  },
  FS_TUNE_REJECTIONS: {
    path: '/fs-tune-rejections',
    name: 'fs_tune_rejections',
    meta: { requiresAuth: true },
    props: { project: 'five-surveys' },
    component: () => import('@ps_views/shared/tune-rejections/TuneRejectionsIndex.vue')
  },
  FS_ADJUST_CONFIG: {
    path: '/fs-adjust-config',
    name: 'fs_adjust_config',
    meta: {
      requiresAuth: true
    },
    props: { project: 'five-surveys' },
    component: () => import('@ps_views/shared/adjust-config/AdjustConfigIndex.vue')
  },
  FS_USER_CREDIT: {
    type: 'function',
    path: 'fs_user_credit',
    name: 'fs_user_credit',
    permission: 'fs_user_credit',
    meta: {
      requiresAuth: true
    }
  },
  FS_DYNAMIC_CAMPAIGNS: {
    path: '/fs-dynamic-campaigns',
    name: 'fs_dynamic_campaigns_main',
    meta: {
      requiresAuth: true
    },
    props: { project: 'five-surveys' },
    component: () => import('@fs_views/DynamicCampaigns')
  },
  FS_DYNAMIC_CAMPAIGNS_EMAILS: {
    path: '/fs-dynamic-campaigns/emails',
    name: 'fs_dynamic_campaigns_emails',
    meta: {
      requiresAuth: true
    },
    props: { project: 'five-surveys' },
    component: () => import('@fs_views/DynamicCampaigns/Pages/Emails/CampaignsEmails.vue')
  },
  FS_DYNAMIC_CAMPAIGNS_EMAILS_CREATE: {
    path: '/fs-dynamic-campaigns/emails/create',
    name: 'fs_dynamic_campaigns_emails_create',
    meta: {
      requiresAuth: true
    },
    props: { project: 'five-surveys' },
    component: () => import('@fs_views/DynamicCampaigns/Pages/Emails/CampaignsEmailsCreateAndEdit.vue')
  },
  FS_DYNAMIC_CAMPAIGNS_EMAILS_EDIT: {
    path: '/fs-dynamic-campaigns/emails/edit/:id',
    name: 'fs_dynamic_campaigns_emails_edit',
    meta: {
      requiresAuth: true
    },
    props: { project: 'five-surveys' },
    component: () => import('@fs_views/DynamicCampaigns/Pages/Emails/CampaignsEmailsCreateAndEdit.vue')
  },
  FS_DYNAMIC_CAMPAIGNS_EMAILS_TRANSLATIONS_EDIT: {
    path: '/fs-dynamic-campaigns/emails/:id/translations/edit/:language_code',
    name: 'fs_dynamic_campaigns_emails_translations_edit',
    meta: {
      requiresAuth: true
    },
    props: { project: 'five-surveys' },
    component: () => import('@fs_views/DynamicCampaigns/Pages/Emails/CampaignsEmailsTranslationsEdit.vue')
  },
  FS_DYNAMIC_CAMPAIGNS_PUSH_NOTIFICATIONS: {
    path: '/fs-dynamic-campaigns/push-notifications',
    name: 'fs_dynamic_campaigns_push_notifications',
    meta: {
      requiresAuth: true
    },
    props: { project: 'five-surveys' },
    component: () => import('@fs_views/DynamicCampaigns/Pages/PushNotifications/CampaignsPushNotifications.vue')
  },
  FS_DYNAMIC_CAMPAIGNS_PUSH_NOTIFICATIONS_CREATE: {
    path: '/fs-dynamic-campaigns/push-notifications/create',
    name: 'fs_dynamic_campaigns_push_notifications_create',
    meta: {
      requiresAuth: true
    },
    props: { project: 'five-surveys' },
    component: () => import('@fs_views/DynamicCampaigns/Pages/PushNotifications/CampaignsPushNotificationsCreateAndEdit.vue')
  },
  FS_DYNAMIC_CAMPAIGNS_PUSH_NOTIFICATIONS_EDIT: {
    path: '/fs-dynamic-campaigns/push-notifications/edit/:id',
    name: 'fs_dynamic_campaigns_push_notifications_edit',
    meta: {
      requiresAuth: true
    },
    props: { project: 'five-surveys' },
    component: () => import('@fs_views/DynamicCampaigns/Pages/PushNotifications/CampaignsPushNotificationsCreateAndEdit.vue')
  },
  FS_DYNAMIC_CAMPAIGNS_PUSH_NOTIFICATIONS_TRANSLATIONS_EDIT: {
    path: '/fs-dynamic-campaigns/push-notifications/:id/translations/edit/:language_code',
    name: 'fs_dynamic_campaigns_push_notifications_translations_edit',
    meta: {
      requiresAuth: true
    },
    props: { project: 'five-surveys' },
    component: () => import('@fs_views/DynamicCampaigns/Pages/PushNotifications/CampaignsPushNotificationsTranslationsEdit.vue')
  },
  FS_USER_REWARD_ELIGIBILITY_LOGS: {
    path: '/fs-user-reward-eligibility-logs',
    name: 'fs_user_reward_eligibility_logs',
    meta: {
      requiresAuth: true
    },
    component: () => import('@fs_views/Users/UserRewardEligibilityLogs')
  },
  FS_OVERWRITE_ELIGIBLE: {
    type: 'function',
    path: 'fs_overwrite_eligible',
    name: 'fs_overwrite_eligible',
    permission: 'fs_overwrite_eligible',
    meta: {
      requiresAuth: true
    }
  }
}
